import { useInstantSearch, useMenu, useSearchBox } from 'react-instantsearch';

import InstantSearchBranchChip from './instantSearchBranchChip';
import InstantSearchTrendingVehicles from './instantSearchTrendingVehicles';
import StockAlertLauncher from '@javascript/components/stock_alerts/stockAlertLauncher';

import { useCustomClearRefinements } from '@javascript/lib/hooks/useCustomClearRefinements';
import useQueryParam from '@javascript/lib/hooks/useQueryParam';

export type NoResultsBoundaryProps = {
  children: JSX.Element;
  branches?: Record<string, string>;
};

const NoResultsBoundary = ({ children, branches }: NoResultsBoundaryProps) => {
  const { results } = useInstantSearch();
  const { clear } = useSearchBox();
  const { refine } = useCustomClearRefinements();

  const [stockAlertParams] = useQueryParam();
  const [branchID] = useQueryParam('branch_id');

  const { refine: refineBranch } = useMenu({ attribute: 'branchID' });

  const selectedBranch = branchID && branches?.[branchID.toUpperCase()];

  const resetSearch = () => {
    clear();
    refine();
  };

  const resultsLabel = 'No results found';

  if (results.__isArtificial || results.nbHits !== 0) return children;

  return (
    <>
      <div className="ac-instant-search__no-results ch-display--flex ch-flex-direction--column ch-align-items--center ch-mt--6 sm:ch-mt--9">
        <section className="ch-text--center">
          <h3 className="ch-fs--5 sm:ch-fs--6">
            {selectedBranch ? `${resultsLabel} at` : resultsLabel}
          </h3>
          {selectedBranch && (
            <span className="ch-display--inline-block ch-pv--2">
              <InstantSearchBranchChip
                branchName={selectedBranch}
                resetBranch={() => refineBranch('')}
              />
            </span>
          )}
          <p className="ch-fs--3 sm:ch-fs--4 ch-ph--6 sm:ch-ph--2">
            Try adjusting your search or{' '}
            <button
              className="ch-btn ch-btn--link ch-fs--3 sm:ch-fs--4 ch-pl--0 ch-pr--1"
              onClick={resetSearch}
              type="button"
            >
              reset
            </button>
            to start again.
          </p>
          <span className="ch-text-divider ch-mt--7 ch-mb--4 sm:ch-mv--5 ch-ph--6 ch-fw--400 ch-bc--grey-3 ch-color--grey-6 ch-fs--3">
            Or
          </span>
          <div className="ch-card ch-pv--4 ch-ph--3 ch-rounded--md">
            <h4 className="ch-fs--4">Create a stock alert</h4>
            <p className="ch-fs--3">
              We&apos;ll let you know as soon as your perfect car comes into
              stock.
            </p>
            <StockAlertLauncher
              additionalStyling="ch-btn--secondary ch-width--12"
              stockAlertUrl={`/stock-alerts/new${stockAlertParams}`}
            />
          </div>
        </section>
      </div>
      <InstantSearchTrendingVehicles />
    </>
  );
};

export default NoResultsBoundary;
